export class EnaioFrontendSortColumn {
    id: string;
    ascending = true;
}
